import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEye, FaEdit, FaTrash, FaSearch } from "react-icons/fa";

const taskData = [
  {
    id: 1,
    taskName: "Task A",
    summary: "This is the summary of Task A",
    program: "Program 1",
    selectedProgram: "SP 1",
    module: "Module 1",
    topic: "Topic 1",
  },
  {
    id: 2,
    taskName: "Task B",
    summary: "This is the summary of Task B",
    program: "Program 2",
    selectedProgram: "SP 2",
    module: "Module 2",
    topic: "Topic 2",
  },
  {
    id: 3,
    taskName: "Task C",
    summary: "Summary for Task C goes here",
    program: "Program 1",
    selectedProgram: "SP 1",
    module: "Module 1",
    topic: "Topic 1",
  },
];

const ShowTask = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [programFilter, setProgramFilter] = useState("");

  const filteredTasks = taskData.filter(
    (task) =>
      (task.taskName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        task.summary.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (programFilter ? task.program === programFilter : true)
  );

  const uniquePrograms = [...new Set(taskData.map((task) => task.program))];

  useEffect(() => {
    // API Call logic goes here
  }, []);

  return (
    <AdminAppBody
      content={
        <div className="container">
          <PageHeading
            title="Task List"
            subTitle="View, edit, or delete assigned tasks."
          />

          <div className="card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-md-3">
                  <h5 className="mb-0 fw-semibold">Tasks</h5>
                </div>

                <div className="col-md-5">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by task name or summary"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={programFilter}
                    onChange={(e) => setProgramFilter(e.target.value)}
                  >
                    <option value="">Filter by Program</option>
                    {uniquePrograms.map((prog, idx) => (
                      <option key={idx} value={prog}>
                        {prog}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Task Name</th>
                    <th className="px-4 py-2">Summary</th>
                    <th className="px-4 py-2">Program</th>
                    <th className="px-4 py-2">Selected Program</th>
                    <th className="px-4 py-2">Module</th>
                    <th className="px-4 py-2">Topic</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTasks.map((task, index) => (
                    <tr key={task.id} className="border-bottom">
                      <td className="px-4 py-2">{index + 1}</td>
                      <td className="px-4 py-2">{task.taskName}</td>
                      <td className="px-4 py-2">{task.summary}</td>
                      <td className="px-4 py-2">{task.program}</td>
                      <td className="px-4 py-2">{task.selectedProgram}</td>
                      <td className="px-4 py-2">{task.module}</td>
                      <td className="px-4 py-2">{task.topic}</td>
                      <td className="px-4 py-2 text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <button className="RVBtn" title="View Task">
                            <FaEye />
                          </button>
                          <button className="RVBtn" title="Edit Task">
                            <FaEdit />
                          </button>
                          <button className="RVBtn" title="Delete Task">
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {filteredTasks.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        No tasks found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ShowTask;
